import { render, staticRenderFns } from "./courseInfoSetting.vue?vue&type=template&id=3a9bf649&scoped=true&"
import script from "./courseInfoSetting.vue?vue&type=script&lang=js&"
export * from "./courseInfoSetting.vue?vue&type=script&lang=js&"
import style0 from "./courseInfoSetting.vue?vue&type=style&index=0&id=3a9bf649&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9bf649",
  null
  
)

export default component.exports